<template>
  <div class="myYiAn">
    <!-- 我的医案/档案 -->
    <div class="first-div fl margin20 border-ddd">
      <div style="width:100%">
        <div
          class="door fl shou"
          v-for="(item, index) in dataList"
          :key="index"
          @click="zhenduanF(item)"
          :class="item.addBorder ? 'red-border' : ''"
        >
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="door-left">
                <img
                  :src="require('@/assets/img/nan.png')"
                  alt
                  v-if="item.sex === '男'"
                />
                <img :src="require('@/assets/img/nv.png')" alt v-else />
              </div>
            </el-col>
            <el-col :span="19">
              <div class="door-right">
                <p class="margin10">
                  <span>{{ limitMaxWords(6, item.name) }}</span
                  >&nbsp;&nbsp;
                  <!--                  <span class="ziji relation" v-if="item.type === '本人'"-->
                  <!--                    >本人</span-->
                  <!--                  >-->
                  <!--               -->
                  <!--                  <span class="qita relation" v-else>{{ item.type }}</span>-->
                </p>
                <p class="margin10 grey-word">
                  <span>性别：{{ item.sex }}</span
                  >&nbsp;&nbsp;
                  <span>年龄：{{ item.age }}岁</span>
                </p>
                <p>
                  <span class="guanYian" @click="editYiAn(item.id)"
                  >管理医案</span
                  >
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="door fl">
        <el-row type="flex" class="row-bg set-t-b-padding" justify="center">
          <el-col :span="6">
            <img
              :src="require('@/assets/img/add2.png')"
              alt
              @click="addYian()"
              class="shou"
            />
          </el-col>
          <el-col :span="12">
            <p class="grey-word">
              <span class="addMedical shou" @click="addYian()"
              >添加医案</span
              >
            </p>
          </el-col>
        </el-row>
      </div>
    </div>




    <!--     添加检索 功能呢-->
    <div style="clear:both">
      <el-form ref="form" :model="searchform" label-width="70px" style="display: flex">
        <el-form-item label="姓名">
          <el-input size="mini" v-model="searchform.name" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item class="left10" label="诊断时间">
          <el-date-picker
            v-model="searchform.firstTime"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="queryBtn">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="second-div margin20 border-ddd">
      <span class="red-color">诊断记录</span>
      <el-button class="small-btn fr red-long-btn" @click="zizhen()"
      >前往诊断</el-button
      >
    </div>
    <el-alert
    title="需要先单击选择上方的自测医案才能查看用户的诊断记录"
    type="success" v-if="!dangAnDataList.length && dangAnDataListFlag">
  </el-alert>
  <el-alert
  title="该自测医案还没有自测信息，快去诊断一下吧"
  type="success" v-if="!dangAnDataList.length && !dangAnDataListFlag">
</el-alert>
    <div class="third">
      <el-row
        class="margin20 bg-white border-ddd set-padding"
        v-for="(item, index) in dangAnDataList"
        :key="index">
        <el-col :span="1" style="margin-top:15px">
          <img :src="require('@/assets/img/nan.png')" alt v-if="item.sex === '男'"/>
          <img :src="require('@/assets/img/nv.png')" alt v-else />
        </el-col>
        <el-col :span="23" style="padding-left:10px">
          <el-row>
            <el-col :span="24">
              <p style="padding-bottom:15px">
                <span>{{ item.name }}</span
                >&nbsp;&nbsp;&nbsp;
                <span class="grey-word">{{
                    limitMaxWords(20, item.disease)
                  }}</span>
                <el-button
                  type="warning"
                  class="small-btn fr"
                  @click="fuZhen(item)"
                  v-if="item.subsequentVisit == '1'"
                >复诊</el-button
                >
              </p>
            </el-col>
          </el-row>
          <div class="dotted-line1"></div>
          <el-row>
            <el-col :span="24">
              <p>
                <span class="fl">
                  {{ toChinesNum(item.unmber) }}诊时：
                  <span v-if="item.gfList.length">《
                    <template v-for="(cur,i) in item.gfList">
                      {{ cur.rectificationName }} <i v-if="i !=item.gfList.length-1">,</i>
                    </template>
                    》</span>
                </span>
                <span class="fr grey-word">{{ item.appVisitTime }}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <p>
                <span class="grey-word text-justity">{{
                    limitMaxWords(50, item.fangGe)
                  }}</span>
                <span
                  class="red-color-font shou"
                  @click="viewDetail(item.id, item.medId)"
                >
                  查看详情
                  <i class="el-icon-d-arrow-right"></i>
                </span>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :class="isDisplay ? 'displayNone' : ''">
        <el-col>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="dangAnPage.total"
            :page-size="dangAnPage.pageSize"
            :current-page.sync="dangAnPage.pageNum"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "myYiAn",
  data() {
    return {
      // 医案分页
      yiAnPage: {
        pageNum: 1,
        pageSize: 100,
        total: 0
      },
      dataList: [], //医案数据
      dangAnDataList: [], //档案数据
      // 档案分页
      dangAnPage: {
        pageNum: 1,
        pageSize: 6,
        total: 0
      },
      searchform: {},
      selectYaId: "", //已经选择了的医案id
      isDisplay: true, //不显示
      dangAnDataListFlag:true,//自测医案的提示展示
    };
  },
  methods: {
    //档案选页
    handleCurrentChange(v) {
      let that = this;
      that.dangAnPage.pageNum = v; //当前页
      that.dangAnList(that.selectYaId);
    },
    //医案列表
    getList() {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let params = {
        userId: that.userInfo.id,
        pageNum: that.yiAnPage.pageNum,
        pageSize: that.yiAnPage.pageSize
      };
      let url = "medicalCasesPc/getYaByUserId";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            for (const item of res.data.list) item.addBorder = false;
            that.dataList = res.data.list;
            that.yiAnPage.total = res.data.total;
            that.yiAnPage.pageSize = res.data.pageSize;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    // 自测记录 查询
    queryBtn() {
      this.dangAnList(this.selectYaId)
    },
    //档案列表
    dangAnList(id) {
      let that = this;
      let userInfo = null;
      if (sessionStorage.getItem("userInfo")) {
        userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let params = {
        id: id,
        name: this.searchform.name,
        firstTime: this.searchform.firstTime,
        pageNum: that.dangAnPage.pageNum,
        pageSize: that.dangAnPage.pageSize,
        userId: userInfo.id,
      };
      let url = "medicalCasesPc/getArchivesByMedId";
      that.$http
        .post(url, params)
        .then(res => {
          this.dangAnDataListFlag = true;
          res = res.data;
          if (res.code == 200) {
            that.dangAnDataList = res.data.list;
            if (that.dangAnDataList.length > 0) {
              that.isDisplay = false;
            } else {
              that.isDisplay = true;
              this.dangAnDataListFlag = false;
              // that.$message({
              //     type: "warning",
              //     message: "此医案没有诊断记录!"
              // });
            }
            that.dangAnPage.total = res.data.total;
            that.dangAnPage.pageSize = res.data.pageSize;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //查看档案详情
    viewDetail(id, medId) {
      this.$router.push({
        path: "/recResults",
        query: { id: id, medId: medId , name: "1"}
      });
    },
    //添加医案
    addYian() {
      this.$router.push({
        path: "/addMedical"
      });
    },
    //编辑医案
    editYiAn(id) {
      this.$router.push({
        path: "/addMedical",
        query: { id, id }
      });
    },
    //选择了一个医案
    zhenduanF(item) {
      let that = this;
      for (const i of that.dataList) i.addBorder = false;
      item.addBorder = true;
      that.zhenduan = true;
      that.selectYaId = item.id;
      that.dangAnList(that.selectYaId);
    },
    //前往诊断
    zizhen() {
      let that = this;
      if (that.selectYaId) {
        that.$router.push({
          path: "/diagnosis",
          query: { id: that.selectYaId }
        });
      } else {
        that.$message({
          type: "warning",
          message: "请您先选择一个医案"
        });
      }
    },
    fuZhen(item) {
      this.$router.push({
                path: "/diagnosis",
                query: { 
                    id: item.medId,
                     firstArchivesId:item.firstArchivesId?item.firstArchivesId:item.id
                    }
            });
    }
  },
  created() {
    this.getList();
    console.log('moment(a).utc().format();', moment('2021/12/31  12:00:00').utc().format())
  }
};
</script>

<style scoped>
.left10{
  margin-left: 10px;
}
.grey-word{
  font-size: 13px;
}
.displayNone {
  display: none;
}
/* .myYiAn {
    padding: 0px 20px;
} */
.first-div {
  background-color: #fff;
  padding: 20px 0px 10px 20px;
  width: 97.4%;
}
.door {
  padding: 10px 0px 10px 10px;
  margin: 0px 10px 10px 0px;
  width: 22%;
  height: 80px;
  border: solid 1px #dddddd;
}
.door:nth-child(4n + 4) {
  margin-right: 0px;
}
.relation {
  color: #fff;
  border-radius: 8px;
  padding: 2px;
}
.ziji {
  background-color: #f64420;
}
.qizi {
  background-color: #f78719;
}
.fuqin {
  background-color: #20cacc;
}
.muqin {
  background-color: #1e9ce4;
}
.qita {
  background-color: #989898;
}

.guanYian {
  background-color: #bfbfbf;
  opacity: 0.8;
  color: #fff;
  padding: 4px 8px;
}
.addMedical {
  line-height: 36px;
}
.set-t-b-padding {
  padding: 20px 0px;
}
.second-div {
  background-color: #fff;
  padding: 13px 20px;
}
.red-color {
  color: #f64420;
  border-bottom: 3px solid #f64420;
  padding-bottom: 14px;
}
.red-border {
  border: solid 1px #f64420;
}
.el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/myYiAn.vue